import * as firebase from 'firebase/app';
import 'firebase/auth';

export const forgotPasswordFunction = async (email: string) => {
  const response = await firebase.auth().sendPasswordResetEmail(email);
  return response;
};

export const facebookLogin = async () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  return await firebase.auth().signInWithPopup(provider);
};

export const googleLogin = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  return await firebase.auth().signInWithPopup(provider);
};

const app = firebase.initializeApp({
  // apiKey: process.env.REACT_APP_FIREBASE_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  // databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,

  apiKey: 'a6ad62eb-d6d7-4b05-85fa-d1da8c5d7c6e',
  authDomain: 'qagil-354fe.firebaseapp.com',
  databaseURL: 'https://qagil-354fe.firebaseio.com',
  projectId: 'qagil-354fe',
  storageBucket: 'qagil-354fe.appspot.com',
  messagingSenderId: '819930092990',
  appId: '1:819930092990:web:6a43d76f4e7dd0b7af55ef',
  measurementId: 'G-1HCV3SQ31',
});

export default app;
